import { Button, Icon, Shadow, Text, HStack, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { Utils, useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React, { useState } from 'react';

import { CardListItemProps } from '../..';
import { TransactionFlowDetails } from '../../../../../../TransactionFlowDetails';
import { LateralBar } from '../../../LateralBar';

export const CardProductItemDesktop: React.FC<CardListItemProps> = ({
  label,
  renderFields,
  hasButtonDetails,
  onPressDetails,
  productData,
  productDefinition,
  color,
}) => {
  const [showInlineList, setShowInlineList] = useState(false);
  const shouldUseInlineList = useBreakpointValue({ base: false, sm: true });

  const handleDetailPress = () => {
    if (shouldUseInlineList) {
      setShowInlineList((prev) => !prev);
    } else {
      onPressDetails?.();
    }
  };

  return (
    <VStack space={Spacing['stack.nano']}>
      <Shadow level={1} borderRadius="sm" p="20px">
        <LateralBar backgroundColor={color} borderTopLeftRadius="sm" borderBottomLeftRadius="sm" />
        <HStack justifyContent="space-between" alignItems="center" w="full">
          <Text fontSize={Typography['fontsize.md']} variant="semibold">
            {label.toUpperCase()}
          </Text>

          <HStack justifyContent="space-between" space={Spacing['inline.xxs']}>
            <HStack space={Spacing['inline.nano']} alignItems="center">
              {renderFields.map((field, index) => (
                <VStack
                  key={index}
                  space={Spacing['inline.quarck']}
                  alignItems="flex-start"
                  minW="130px">
                  <Text fontSize={Typography['fontsize.xs']} color="neutral.medium">
                    {field.label}
                  </Text>
                  <Text
                    fontSize={Typography['fontsize.md']}
                    color={field.value >= 0 ? 'neutral.darkest' : 'feedback.error.default'}
                    variant="semibold">
                    {Utils.Mask.Money(field.value)}
                  </Text>
                </VStack>
              ))}
            </HStack>

            {hasButtonDetails && (
              <Button
                onPress={handleDetailPress}
                rightIcon={
                  shouldUseInlineList && (
                    <Icon name={showInlineList ? 'ChevronUp' : 'ChevronDown'} size="xs" />
                  )
                }
                variant="textLink"
                padding={0}>
                DETALHES
              </Button>
            )}
          </HStack>
        </HStack>
      </Shadow>

      {shouldUseInlineList && showInlineList && (
        <Box
          padding="inline.nano"
          marginY="inline.quarck"
          backgroundColor="background"
          borderRadius="sm">
          <TransactionFlowDetails
            defaultProduct={{ product: productDefinition, data: productData }}
            isInline
          />
        </Box>
      )}
    </VStack>
  );
};
